import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, Mail, CheckCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Link to="/" className="font-outfit text-3xl font-bold text-[#D4AF37]">Prestigious Wireless</Link>
          <p className="text-[#A0A0A0] mt-3 font-manrope">Reset your password</p>
        </div>

        {sent ? (
          <div className="bg-[#0F0F0F] border border-[#2A2A2A] rounded-2xl p-8 text-center" data-testid="reset-sent">
            <CheckCircle className="w-16 h-16 text-emerald-400 mx-auto mb-4" />
            <h2 className="font-outfit text-xl font-bold text-[#F5F5F5] mb-2">Check Your Email</h2>
            <p className="text-[#A0A0A0] font-manrope text-sm mb-6">
              If an account exists for <span className="text-[#F5F5F5]">{email}</span>, we've sent a password reset code.
            </p>
            <Link to="/reset-password" className="block w-full bg-[#D4AF37] hover:bg-[#F0C541] text-black py-3 rounded-full font-semibold transition-all" data-testid="go-to-reset">
              Enter Reset Code
            </Link>
            <p className="text-[#A0A0A0] text-xs font-manrope mt-4">Didn't receive it? Check spam or <button onClick={() => setSent(false)} className="text-[#D4AF37] underline">try again</button></p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-[#0F0F0F] border border-[#2A2A2A] rounded-2xl p-8 space-y-6" data-testid="forgot-password-form">
            {error && <div className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 rounded-xl text-sm font-manrope">{error}</div>}
            <div className="flex items-center gap-3 mb-2"><Mail className="w-5 h-5 text-[#D4AF37]" /><p className="text-[#F5F5F5] font-manrope">Enter your email and we'll send you a reset code.</p></div>
            <div>
              <label className="block text-[#A0A0A0] text-sm font-manrope mb-2">Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                className="w-full bg-[#0F0F0F] border border-[#2A2A2A] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] rounded-xl px-4 py-3 text-[#F5F5F5] font-manrope outline-none transition-all"
                placeholder="you@example.com" data-testid="forgot-email-input" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#D4AF37] hover:bg-[#F0C541] text-black py-3.5 rounded-full font-semibold text-lg transition-all disabled:opacity-50 flex items-center justify-center gap-2"
              data-testid="forgot-submit">
              {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Sending...</> : "Send Reset Code"}
            </button>
            <p className="text-center text-[#A0A0A0] text-sm font-manrope">
              Remember your password? <Link to="/login" className="text-[#D4AF37] font-semibold">Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
